import { createFileRoute } from '@tanstack/react-router';
import { RaiseInvoices } from '../../../features/sales-invoicing/RaiseInvoices';

/** Owned by G23. "Raise invoices" (BUILD_SPEC.md §8.4 step 4). */
export const Route = createFileRoute('/_authenticated/sales-invoicing/raise')({
  component: RaiseInvoices,
});
